import { ButtonTriggerEvent } from '../../../common/components';
import { HubPlace } from '../../../models/hub/hub.place';

export class EditCityModalActions {
    confirm: (event: ButtonTriggerEvent, image: any) => void;
    cancel?: () => void;
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/edit.city.modal/edit.city.modal.provider.ts